import { render, staticRenderFns } from "./Juridique.vue?vue&type=template&id=16559abf&"
import script from "./Juridique.vue?vue&type=script&lang=js&"
export * from "./Juridique.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports